
export default {
  label: 'label-override',
  group: 'form-group',
  displayWrapper: '',
  input: 'form-control',
};



// WEBPACK FOOTER //
// src/common/form-elements/int-element-folder/int-element.style.js